module.exports = __webpack_public_path__ + "img/p1-c3-p5.4293c814.jpg";